<app-spinner [isLoading]="isLoadingSpinner"></app-spinner>

<div class="payer-shell" *ngIf="!isLoadingSpinner">
  <main class="payer-main auth-main">
    <div class="page-width-auth u-full-width">
      <div class="card card-elevated">
        <div class="card-body auth-card-body">
          <span class="brand-mark" aria-hidden="true">P</span>
          <!-- Sign-up disabled — see login.component.ts. Original toggled heading: -->
          <!-- <h1>{{ isSignUpMode ? 'Sign up' : 'Sign in' }}</h1> -->
          <h1>Sign in</h1>
          <p>Manage merchants and their payment pages.</p>

          <div
            *ngIf="configLoadError"
            class="alert alert-warning auth-error"
            role="status"
            aria-live="polite"
          >
            <svg class="icon alert-icon" viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <line x1="12" y1="8" x2="12" y2="13" />
              <line x1="12" y1="16" x2="12" y2="16.01" />
            </svg>
            <span class="alert-body">Some settings couldn't be loaded, but you can still sign in.</span>
          </div>

          <!-- Sign-up disabled — original: (ngSubmit)="isSignUpMode ? signUp() : login()" -->
          <form
            [formGroup]="loginForm"
            (ngSubmit)="login()"
            class="field-group auth-form"
          >
            <div class="form-outline">
              <label class="form-label" for="typeEmailX-2">Email</label>
              <input
                type="email"
                id="typeEmailX-2"
                class="form-control form-control-lg"
                formControlName="email"
                autocomplete="email"
              />
            </div>

            <div class="form-outline">
              <label class="form-label" for="typePasswordX-2">Password</label>
              <input
                type="password"
                id="typePasswordX-2"
                class="form-control form-control-lg"
                formControlName="password"
                autocomplete="current-password"
              />
              <a
                href="#"
                class="text-small text-link auth-forgot-link"
                (click)="$event.preventDefault()"
                >Forgot password?</a
              >
            </div>

            <!-- Sign-up disabled — original: {{ isSignUpMode ? 'Sign up' : 'Sign in' }} -->
            <button type="submit" class="btn btn-primary btn-lg btn-block">
              Sign in
            </button>
          </form>

          <!-- Sign-up disabled — original condition: *ngIf="!isSignUpMode && showSignUp" -->
          <ng-container *ngIf="showSignUp">
            <div class="auth-divider">
              <span></span>
              <span class="text-caption">or</span>
              <span></span>
            </div>

            <button class="btn btn-secondary btn-lg btn-block" (click)="loginWithGoogle()">
              Continue with Google
            </button>

            <!-- Sign-up entry point disabled — kept for future use:
            <button class="btn btn-link auth-toggle-link" (click)="toggleSignUpMode()">
              {{
                isSignUpMode
                  ? 'Already have an account? Sign in'
                  : 'Need an account? Request access'
              }}
            </button>
            -->
          </ng-container>

          <div
            *ngIf="errorText"
            class="alert alert-danger auth-error"
            role="alert"
            aria-live="polite"
          >
            <svg class="icon alert-icon" viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <line x1="12" y1="8" x2="12" y2="13" />
              <line x1="12" y1="16" x2="12" y2="16.01" />
            </svg>
            <span class="alert-body">{{ errorText }}</span>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
